import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
export function PriceReasonSection() {
  const steps = ["Print the worksheets.", "Work through the cases.", "Write down your observations before reading the review.", "Compare your reasoning.", "Return to the pathway whenever you review another educational case."];
  return <Section tone="cream" narrow cta="I want to start using the system" data-id="element-235" data-mp="2gy1aocz2iylj">
      <SectionHeading title={<>
            I intentionally <em className="text-rose" data-id="element-237" data-mp="2ltoxilq2vfnv">kept the price low</em>
          </>} subtitle="Because I want you to actually use the system." data-id="element-236" data-mp="2lwkxsgpeegfh" />
      <ul className="mx-auto mt-8 max-w-xl space-y-3" data-id="element-238" data-mp="2cu1vpytfs7ua">
        {steps.map(s => <li key={s} className="flex gap-3 rounded-xl bg-white p-4 text-[16px] font-medium text-ink" data-id="element-239" data-mp="wgv6fzwo7rug">
            <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-240" data-mp="11h95wtk7htgv" />
            {s}
          </li>)}
      </ul>
      <p className="mx-auto mt-8 max-w-xl text-center font-serif text-xl font-bold leading-snug text-ink md:text-2xl" data-id="element-241" data-mp="ikes8xfuwzgp">
        The value isn't in reading the pages once. The value is in using the process repeatedly.
      </p>
    </Section>;
}
export function GuaranteeSection() {
  const items = ["Open all six volumes", "Review the complete pathway", "Work through educational cases", "Download the worksheets", "Use the case-review tools", "Explore all five bonuses"];
  return <Section tone="white" narrow cta="Try it risk-free for 7 days" data-id="element-242" data-mp="wg8zlc0zfgrp">
      <div className="rounded-3xl border-2 border-dashed border-cta/50 bg-cream p-6 text-center md:p-10" data-id="element-243" data-mp="1b6g8b016tlf7">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-cta text-white" data-id="element-244" data-mp="168oicbk3s9dn">
          <ShieldCheckIcon className="h-10 w-10" aria-hidden="true" data-id="element-245" data-mp="1k5lb4ijs80x6" />
        </span>
        <h2 className="mt-5 font-serif text-[30px] font-bold leading-tight text-ink md:text-4xl" data-id="element-246" data-mp="1g7xbx3b23lzh">My 7-day guarantee</h2>
        <p className="mt-3 text-[17px] text-inkSoft" data-id="element-247" data-mp="1n7fxok1h4zow">
          Try the Breast Augmentation Clinical Pathway™ without risk. For 7 days, you can:
        </p>
        <ul className="mx-auto mt-6 grid max-w-lg gap-2 text-left sm:grid-cols-2" data-id="element-248" data-mp="1x6oox54yg07k">
          {items.map(i => <li key={i} className="flex gap-2.5 text-[16px] text-ink" data-id="element-249" data-mp="21zqatx3kx00n">
              <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-250" data-mp="25yqnexvgr6f7" />
              {i}
            </li>)}
        </ul>
        <p className="mt-6 text-[16px] leading-relaxed text-inkSoft" data-id="element-251" data-mp="2b0oegea3v5ip">
          If you decide the system isn't useful for your professional learning workflow, you can request a refund
          according to the purchase terms.
        </p>
      </div>
    </Section>;
}